const AppSettings = {
    VERSION: '6.0.0',
    ENV: 'production',
    SENTRY_DSN: 'https://f2addee7c0a849c28f0049d6f1fc04c7@sentry.io/278221',
    googleAnalyticsId: 'G-HVD6P0GK8F',
    googleApiURLKey: 'AIzaSyCItcgw6J6eZxVzHcke7SUJ_gUewOdw_z4',
    routes: {
        api: '/api',
        gateway: '/api/gateway',
    },
    launchDarklyClientSideId: '65d46b4443c600100518f0f3',
    closelinkChartsUrl: 'https://charts.closelink.com',
    auth0: {
        domain: 'auth.closelink.com',
        clientId: 'FrYCsjOEHCBLXCsIcylct2maZlkIuRJS',
        audience: 'https://api.closelink.com',
        cookieDomain: '.closelink.com',
    },
    survicateWorkspaceKey: 'b881f11c6f8b532018f7ed9ad846e39c',
    survicateSurveyId: {
        customer: '41d86f9de53ac7bf',
        supplier: '81e842636671524b',
    },
    approvalTokenEncryptionKey: '7K9mP2xQ8vN4wR6z',
};

export default AppSettings;
